export default __webpack_public_path__ + "static/media/bnr9.0ff20a9e.jpg";